// extracted by mini-css-extract-plugin
export var active = "_ia-7";
export var blink = "_ia-8";
export var dropDownSelector = "_ia-4";
export var dropDownWrapper = "_ia-3";
export var fakeCursor = "_ia-6";
export var fontSizeButton = "_ia-9";
export var formQuillEditor = "_ia-0";
export var pressed = "_ia-a";
export var qlBlank = "_ia-1";
export var textFormattingToolbar = "_ia-2";
export var textToolbarOption = "_ia-5";